// Cores das bolinhas e barras do relatorio do funil, fora do KanbanReports.vue.
//
// Prioridade usa tokens do tema (mudam com claro e escuro). Canal e etapa sao
// cores de categoria, de saturacao media, legiveis nos dois fundos; as de
// rede social sao as da marca de cada uma.

const token = name => `rgb(var(--${name}))`;

export const NEUTRAL_COLOR = token('slate-9');

const PRIORITY_COLORS = {
  low: token('slate-9'),
  medium: token('amber-9'),
  high: token('ruby-9'),
};

const CHANNEL_COLORS = {
  site: '#3b82f6',
  telefone: '#22c55e',
  whatsapp: '#a855f7',
  email: '#f59e0b',
  chat: '#ef4444',
  facebook: '#1877f2',
  instagram: '#e4405f',
  linkedin: '#0077b5',
  google: '#4285f4',
};

const STAGE_COLORS = {
  novo: '#3b82f6',
  contato: '#f59e0b',
  qualificacao: '#8b5cf6',
  proposta: '#06b6d4',
  negociacao: '#f97316',
  fechamento: '#22c55e',
  ganho: '#22c55e',
  perdido: '#ef4444',
  followup: '#84cc16',
};

export const priorityColor = priority =>
  PRIORITY_COLORS[priority] || NEUTRAL_COLOR;

export const channelColor = (channelName = '') =>
  CHANNEL_COLORS[String(channelName).toLowerCase()] || NEUTRAL_COLOR;

// Chave "Funil: etapa" (todos os funis) usa so a etapa.
export const stageColor = (stageName = '') => {
  const name = String(stageName).includes(':')
    ? String(stageName).split(':')[1].trim()
    : String(stageName);
  return STAGE_COLORS[name.toLowerCase()] || NEUTRAL_COLOR;
};
